import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';
import { roleGuard } from './core/guards/role.guard';
import { superAdminTenantContextGuard } from './core/guards/super-admin-tenant-context.guard';
import { foodVerticalGuard, personalCareVerticalGuard } from './core/guards/food-vertical.guard';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'invite/:token',
    loadComponent: () =>
      import('./features/auth/invite-accept/invite-accept.component').then(
        (m) => m.InviteAcceptComponent
      ),
  },
  {
    path: 'super-admin-invite/:token',
    loadComponent: () =>
      import('./features/auth/super-admin-invite-accept/super-admin-invite-accept.component').then(
        (m) => m.SuperAdminInviteAcceptComponent
      ),
  },
  {
    path: 'forms/:token',
    loadComponent: () =>
      import('./features/forms/form-fill.component').then((m) => m.FormFillComponent),
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [authGuard, superAdminGuard],
    children: [
      {
        path: 'overview',
        loadComponent: () =>
          import('./features/admin/overview/overview.component').then((m) => m.OverviewComponent),
      },
      {
        path: 'tenants',
        loadComponent: () =>
          import('./features/admin/tenants/tenant-list.component').then(
            (m) => m.TenantListComponent
          ),
      },
      {
        path: 'tenants/:id',
        loadComponent: () =>
          import('./features/admin/tenants/tenant-details.component').then(
            (m) => m.TenantDetailsComponent
          ),
      },
      {
        path: 'showcase',
        loadComponent: () =>
          import('./features/showcase/showcase.component').then((m) => m.ShowcaseComponent),
        data: { embedded: true },
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./features/admin/account/account.component').then((m) => m.AdminAccountComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/admin/users/user-list.component').then((m) => m.UserListComponent),
      },
      {
        path: 'whatsapp',
        loadComponent: () =>
          import('./features/admin/whatsapp/super-admin-whatsapp.component').then(
            (m) => m.SuperAdminWhatsAppComponent
          ),
      },
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/main-layout.component').then((m) => m.MainLayoutComponent),
    canActivate: [
      authGuard,
      roleGuard(['admin', 'operator', 'super_admin', 'waiter']),
      superAdminTenantContextGuard,
    ],
    children: [
      {
        path: 'mobile',
        loadChildren: () => import('./features/mobile/mobile.routes').then((m) => m.mobileRoutes),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'conversations',
        loadChildren: () =>
          import('./features/conversations/conversations.routes').then(
            (m) => m.conversationsRoutes
          ),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./features/notifications/notifications.routes').then(
            (m) => m.notificationsRoutes
          ),
      },
      {
        path: 'agenda',
        canActivate: [personalCareVerticalGuard],
        loadChildren: () => import('./features/agenda/agenda.routes').then((m) => m.agendaRoutes),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.settingsRoutes),
      },
      {
        path: 'food-settings',
        canActivate: [foodVerticalGuard, roleGuard(['admin', 'operator', 'super_admin'])],
        loadComponent: () =>
          import('./features/food-settings/food-settings.component').then(
            (m) => m.FoodSettingsComponent
          ),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('./features/contacts/contacts.routes').then((m) => m.contactsRoutes),
      },
      {
        path: 'knowledge-base',
        loadChildren: () =>
          import('./features/knowledge-base/knowledge-base.routes').then(
            (m) => m.knowledgeBaseRoutes
          ),
      },
      {
        path: 'flows',
        loadChildren: () => import('./features/flows/flows.routes').then((m) => m.flowsRoutes),
      },
      {
        path: 'services',
        canActivate: [personalCareVerticalGuard],
        loadChildren: () =>
          import('./features/services/services.routes').then((m) => m.servicesRoutes),
      },
      {
        path: 'collaborators',
        canActivate: [personalCareVerticalGuard],
        loadChildren: () =>
          import('./features/collaborators/collaborators.routes').then(
            (m) => m.collaboratorsRoutes
          ),
      },
      {
        path: 'insights',
        loadChildren: () =>
          import('./features/insights/insights.routes').then((m) => m.insightsRoutes),
      },
      {
        path: 'floor-plan',
        canActivate: [foodVerticalGuard],
        loadChildren: () =>
          import('./features/floor-plan/floor-plan.routes').then((m) => m.floorPlanRoutes),
      },
      {
        path: 'widget-test',
        loadComponent: () =>
          import('./features/widget-test/widget-test.component').then((m) => m.WidgetTestComponent),
      },
      {
        path: 'widget-demo',
        loadComponent: () =>
          import('./features/widget-demo/widget-demo.component').then((m) => m.WidgetDemoComponent),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
];
